const DEFAULT_SCORING_RESULT = { loading: true, loaded: false };
const getDocumentScoringGridsFlags = (state, id) => state.document.scoringData[id].scoringGrids;
const getDocumentScoringResultFlags = (state, id) => state.document.scoringData[id].scoringResult;

export const getDocumentScoringGrids = (state, key) => {
  const scoring = state.document.scoringData[key];
  if (scoring) {
    const flags = getDocumentScoringGridsFlags(state, key);
    if (!flags || !flags.loaded || flags.loading) return [];

    const scoringGrids = state.entities.scoring[key].scoringGrids;
    return scoringGrids;
  }
  return [];
};

export const getDocumentScoringResult = (state, key) => {
  const scoring = state.document.scoringData[key];
  if (scoring) {
    const flags = getDocumentScoringResultFlags(state, key);
    if (!flags || !flags.loaded || flags.loading) return DEFAULT_SCORING_RESULT;

    const scoringResult = state.entities.scoring[key].scoringResult;
    return scoringResult;
  }
  return DEFAULT_SCORING_RESULT;
};

export const getDocumentScoringGridsLoaded = (state, key) => {
  const scoring = state.document.scoringData[key];

  if (scoring && scoring.scoringGrids) {
    return scoring.scoringGrids.loaded;
  }

  return false;
};

export const getDocumentScoringResultLoaded = (state, key) => {
  const scoring = state.document.scoringData[key];

  if (scoring && scoring.scoringResult) {
    return scoring.scoringResult.loaded;
  }

  return false;
};

export const getDimensionPeriods = state => {
  return state.dictionaries.dimensionPeriods.isLoaded ? state.dictionaries.dimensionPeriods.items : [];
};
